// Logged-in app page: clip collections (routes/ClipPacks.tsx). Keep keys in sync with pl/appCollections.ts.
export const appCollections = {
  head: {
    title: 'Collections',
  },
  filter: {
    all: 'All',
    edimi: 'EDIMI',
  },
  create: {
    cta: 'New collection',
    heading: 'New collection',
    name: 'Name',
    submit: 'Create',
  },
  move: {
    title: 'Move to collection',
    none: 'No collection',
  },
  delete: {
    ask: 'Delete the collection “{name}”?',
    body: 'The packs in it stay.',
    submit: 'Delete collection',
  },
  merge: {
    heading: 'Merge packs',
    explain: 'The source packs disappear.',
    totalLabel: 'Clips in total',
    nameLabel: 'Name of the new pack',
    defaultName: '{first} + {n}',
    confirm: 'Merge {count} packs',
    confirm_one: 'Merge {count} pack',
    confirm_few: 'Merge {count} packs',
    confirm_many: 'Merge {count} packs',
  },
  dialog: {
    cancel: 'Cancel',
  },
  toast: {
    deleted: 'Collection deleted.',
  },
  error: {
    nameTaken: 'You already have a collection with that name.',
    title: 'Could not save the collection.',
    retry: 'Try again',
  },
}
